import React, { Component } from 'react'
import Login from '../Login/Login'
import { jumpToLogin } from './componentsv2'
import LoginBar from './components/loginbar'
import CouponBar from './components/CouponBar'
import {TotalPriceBox} from './components/stateless'
import { RenderSubmitBtn } from './components/Renders'
import { TipPop, TipLoadingPop } from './components/Pops'
import { OrangeCounterInOpensale, BlackCounterInOpensale, BlueCounterInOpensale } from './components/counter'
import DiskSelector from './components/diskselector'
import Swiperbox from './components/swiperbox'
import {addToShoppingCart,getOriginData} from '../ShoppingCart/util'
import t from '../../i18n/purchase'
import {
	browser,
    postPromise,
	createUrl,
	// stat,
	getCookie,
	ajaxGet
} from '../../common/utils'
import { ONECLOUD_API_HOST, commonApi } from '../../common/consts'
import { SINGLE_ORDER_MAX_NUM } from '../../common/saleConfig'

const api = {
    getconfig: `${ONECLOUD_API_HOST}/opensale/getconfig`,
    commit: `${ONECLOUD_API_HOST}/opensale/commit`,
    usercouponlist: `${ONECLOUD_API_HOST}/coupon/userCouponList`,
}
const ACT_STATUS_NO = 0 // 无活动，原价
const ACT_STATUS_MJ = 1 // 满减活动
let GET_CONFIG_LOOP_TIMES = 0


// 0-活动未开始,1-抢购中,2-抢购结束
/* 开放售卖原价【CN版】满减活动【CN版】 */
export default class OpensalePurchaseV3 extends Component {
    constructor(props) {
		super(props)
		this.queryParams = {
			isPc: browser('pc') ? true : false
		}
        this.state = {
            hasLogin: false,
			hasDiscount: false,
			shoppingList: {
                orange: 0,
                black:0,
                blue: 1,
                diskCount:0
			},
			priceList: {
				wky: 599,
				disk: 749,
				diskActPrice: 0 // 549
			},
			color: 'blue',
			popShow: false,
			popMsg: '',
			popJump: '',
            popBtn: t('ok'),
            hideClose: false,
			loadingTime: false,
			diskChecked: false,
			totalPrice: 0,
			selectedColor: 'blue',
			sellout: {
				black: false,
				blue: false,
				orange: false,
				disk: false
			},
            couponNum: 0,
            showLoading: false
		}

		this.changeShoppingList = this.changeShoppingList.bind(this)
		this.countTotalPrice = this.countTotalPrice.bind(this)
		this.changeImageColor = this.changeImageColor.bind(this)
		this.handleSubmitAdd = this.handleSubmitAdd.bind(this)
		this.handleSubmitBuy = this.handleSubmitBuy.bind(this)
		this.loginCallback = this.loginCallback.bind(this)
	}

	componentDidMount() {
        $('html').addClass('whitebg')
        this.getConfig()
		this.checkLogin()
	}

	changeImageColor(selected){
        this.setState({selectedColor:selected})
    }
	changeShoppingList(type,count){
		const {shoppingList} = this.state;
        shoppingList[type] = Number(count);
        this.setState({shoppingList},this.countTotalPrice)
	}

	handleSubmitAdd(e) {
		e.preventDefault()
		const { shoppingList: { blue, black, orange, diskCount } } = this.state
		const cartFromLocal = getOriginData()
		const localNumbers = cartFromLocal.blue + cartFromLocal.black + cartFromLocal.orange
		typeof onStatBtnClick === 'function' && onStatBtnClick('add_to_cart', null, `blue=${blue}&orange=${orange}&black=${black}%harddisk=${diskCount}`)
		if (blue + black + orange <= 0) {
			if (localNumbers > 0 && diskCount === 0) {
				this.showPopHandler('请选择商品数量')
				return
			}
			if (localNumbers === 0) {
				this.showPopHandler('请选择玩客云数量')
				return
			}
		}
		addToShoppingCart({
			blue,
			black,
			orange,
			disk: diskCount
		}, (res) => {
			const codeHandlers = {
				70202: () => this.showPopHandler('超过最大可购买数量'),
				70204: () => this.showPopHandler(res.sMsg, () => {
					sellout.black = true
					this.setState({sellout})
					this.changeShoppingList('black', 0)
				}),
				70205: () => this.showPopHandler(res.sMsg, () => {
					sellout.blue = true
					this.setState({sellout})
					this.changeShoppingList('blue', 0)
				}),
				702046: () => this.showPopHandler(res.sMsg, () => {
					sellout.orange = true
					this.setState({sellout})
					this.changeShoppingList('orange', 0)
				})
			}
			if (codeHandlers[res.iRet]) {
				codeHandlers[res.iRet]()
			} else {
				setTimeout(() => {
					window.location.href = '/site/cart.html'
				}, 50)
			}
		}, this.showPopHandler)
	}

	handleSubmitBuy(e) {
		e && e.preventDefault()
        const { hasLogin, shoppingList: { blue, black, orange, diskCount }, hasDiscount } = this.state
		const onecloudCount = blue + black + orange
		typeof onStatBtnClick === 'function' && onStatBtnClick('buynow', null, `blue=${blue}&orange=${orange}&black=${black}%harddisk=${diskCount}`)

		if (onecloudCount <= 0) {
			this.showPopHandler('请选择玩客云数量')
			return
        } else if (onecloudCount > SINGLE_ORDER_MAX_NUM) {
            this.showPopHandler('超过最大可购买数量')
            return
		}
		if (!hasLogin) {
            this.login()
            return
        }

        const postData = {
            sub_type: hasDiscount ? ACT_STATUS_MJ : ACT_STATUS_NO,
			black_num: black,
            orange_num: orange,
            blue_num: blue,
			hd_num: diskCount,

			// product_id: 2, // mini qin.test
		}

		const doneCb = res=> {
			this.closeLoading()
			const success = (data)=> {
                const codeHandlers = {
                    30400: () => this.showPopHandler('超过最大可购买数量'),
                    30016: () => this.showPopHandler(res.sMsg, () => {
                        sellout.black = true
                        this.setState({sellout})
                        this.changeShoppingList('black', 0)
                    }),
                    30026: () => this.showPopHandler(res.sMsg, () => {
                        sellout.blue = true
                        this.setState({sellout})
                        this.changeShoppingList('blue', 0)
                    }),
                    30025: () => this.showPopHandler(res.sMsg, () => {
                        sellout.orange = true
                        this.setState({sellout})
                        this.changeShoppingList('orange', 0)
                    })
                }
                if (codeHandlers[res.iRet]) {
                    codeHandlers[res.iRet]()
                } else {
                    setTimeout(() => {
						window.location.href = createUrl('html/count', {type:'opensale', orderid: data.order_id})

						// qin.test mini下单
                        // window.location.href = createUrl('html/mini-order', {type:'mini', orderid: data.order_id})

                    }, 50)
                }
			}
			this.responeHandler({res, success})
        }
        this.showLoading()
		postPromise(api.commit, postData).done(doneCb).fail(() => this.showNetBusy())
    }

    getConfig = () => {
		if (getCookie('lang') !== 'cn') return
		let doneCb = res => {
			console.log(res);
			let success = data=>{
				const { mj_status, mj_price, hd_price,black_sell_out,blue_sell_out,orange_sell_out } = data
				const {priceList} = this.state;
				let stateData = {}
				if (mj_status == ACT_STATUS_MJ) {
					stateData = {
						hasDiscount: true,
						priceList: {
							...priceList,
							wky: mj_price,
							diskActPrice: hd_price
						},
						sellout: {
							black: black_sell_out,
							blue: blue_sell_out,
							orange: orange_sell_out,
							disk: false
						}
					}
				} else {
					stateData = {
						hasDiscount: false,
						priceList: {
							...priceList,
							wky: 599,
							diskActPrice: hd_price
						},
						sellout: {
							black: black_sell_out,
							blue: blue_sell_out,
							orange: orange_sell_out,
							disk: false
						}
					}
				}
				this.setState(stateData, () => this.countTotalPrice())
			}
			this.responeHandler({res, success})
		}
		let failCb = res => {
			if (GET_CONFIG_LOOP_TIMES == 1) {
				// this.showPopHandler(t('notifi_yongdu'))
				this.showNetBusy()
			} else {
				GET_CONFIG_LOOP_TIMES++
				setTimeout(this.getConfig, 2000);
			}
		}
		postPromise(api.getconfig).done(doneCb).fail(failCb)
	}

    checkLogin() {
        if (window.siteHasLogined) {
            this.setState({
                hasLogin: true
            }, () => this.fetchCoupon())
        } else {
            let doneCb = res => {
                +res.iRet === 0 && this.setState({
					hasLogin: true
				}, () => this.fetchCoupon())
            }
            postPromise(commonApi.checklogin).done(doneCb)
        }
	}

	fetchCoupon() {
		let doneCb = res => {
			+res.iRet === 0 && this.setState({
				couponNum: res.data.list.length
			})
		}
		ajaxGet(`${api.usercouponlist}?status=0`, doneCb)
    }

    login() {
		this.setState({
		  useDefaultMsgDom: false,
		  popShow: true,
		  popMsg: <Login buttonName="立即登录" loginCallback={this.loginCallback} />,
		  popJump: '',
		  popBtn: 'hide',
		  hideClose: false
		})
	}

    loginCallback() {
        this.setState({
			popShow: false,
			hasLogin: true,
		}, () => {
			this.handleSubmitBuy()
		})
	}

    showPopHandler = (msg, url, btn) => {
		this.setState({
			popShow: true,
			popMsg: msg,
			popJump: url || '',
			popBtn: btn || t('ok')
		})
    }

    showNetBusy() {
		this.closeLoading()
		this.showPopHandler('网络繁忙，请稍候重试（S）')
    }

    showLoading() {
		this.setState({ showLoading: true })
	}

	closeLoading() {
		this.setState({ showLoading: false })
	}

    commonErrorHandler(resCode, sMsg) {
		let statusList = {
			'30004' : t('rtncode_30004'),
			'30006' : t('rtncode_30006'),
			'30008' : t('rtncode_30008'),
			'30009' : t('rtncode_30009'),
			'40000' : t('rtncode_40000'),
			'30003' : t('rtncode_30003'),
			'30106' : t('rtncode_30106'),
			'-2' : t('rtncode__2'),
			'-2004': t('rtncode__2004'),
			'-2000': t('rtncode__2000'),
			'-1003': t('rtncode__1003'),
			'-5': t('rtncode__5'),

			"41006": t('rtncode_41006'),
			"41007": t('rtncode_41007_2'),
			"41009": t('rtncode_41009'),
			"41012": t('rtncode_41012'),
			"41013": t('rtncode_41013'),
			"41014": t('rtncode_41014'),
			'41016': t('rtncode_41016'),
			'41018': t('rtncode_41018'),
			"41022": t('rtncode_41022')
		}
		let sellOutList = {
			'30005' : t('rtncode_30005'),
			'30016' : t('rtncode_30016'),
			'30025' : t('rtncode_30025'),
			'30026' : t('rtncode_30026')
		}

		if(resCode == -501){
			let url = window.location.href
			jumpToLogin()
		}else if(resCode == 30007) {
			this.showPopHandler(t('rtncode_30007'), createUrl('html/usercenter'), t('check_order'))
		} else if(resCode == 30303) {
			this.showPopHandler(t('rtncode_30303'))
			this.getConfig()
		}
		else if(sellOutList[resCode]){
			if(resCode==30005){
				this.showPopHandler(sellOutList[resCode])
			}else {
				this.showPopHandler(sellOutList[resCode],'',t('tips_continue'))
				//this.getColorList()
			}
		} else if(statusList[resCode]) {
			this.showPopHandler(statusList[resCode])
		} else if (resCode !== 0) { // CN
			this.showPopHandler(sMsg)
		}
		// if (callback&&typeof callback=="function"){
		// 	callback(resCode,res)
		// }
	}
	responeHandler({res, success}){
		const resCode = res.iRet;
		this.commonErrorHandler(resCode, res.sMsg)

		if(resCode==0) {
			if(res.data){
				success(res.data);
			}else {
				success()
			}
		}
    }

    closePop = ()=> {
        this.setState({popShow: false})
	}
	updateDiskData = (data) => {
		this.setState(data)
	}

	countTotalPrice() {
		const { shoppingList: { orange, black, blue, diskCount }, priceList: { wky, diskActPrice } } = this.state
		const wkyCount = orange + black + blue
		const totalPrice = wkyCount * wky + diskCount * diskActPrice
		this.setState({totalPrice})
	}

    render() {
		const {
            shoppingList: { blue, black, orange }, shoppingList, priceList, hasLogin,
            loadingTime, hasDiscount, totalPrice, selectedColor,sellout,couponNum, showLoading,
            popShow, popBtn, popMsg, popJump, hideClose, useDefaultMsgDom,
		} = this.state
		const { isPc } = this.queryParams

		let tipData = {}
        if (popShow) {
			tipData = {
              msg: popMsg,
              btn: popBtn,
              jump: popJump,
              hideClose,
              onClose: this.closePop,
              useDefaultMsgDom
			}
		}

		return <OpensaleCombiner
					topbar={ hasLogin ? <CouponBar num={couponNum} /> : <LoginBar isLogin={false} /> }
					popcomp={ popShow && <TipPop {...tipData} /> }
					swiper={<Swiperbox selectedColor={selectedColor}/>}
				>
			{hasDiscount? t('mj_price_title'): <OfficialPrice />}
			<ColorSelector sellout={sellout} changeShoppingList={this.changeShoppingList} blue={blue} black={black} orange={orange} selectedColor={selectedColor} changeImageColor={this.changeImageColor}/>
			<DiskSelector changeShoppingList={this.changeShoppingList} shoppingList={shoppingList} priceList={priceList} />
			<TotalPriceBox totalPrice={totalPrice}/>
			<RenderSubmitBtn
				isPc={isPc}
				loadingTime={loadingTime}
				onClickAdd={this.handleSubmitAdd}
				onClickBuy={this.handleSubmitBuy}
				disabled={false}
			/>
            { t('goods_tip') }
            { showLoading && <TipLoadingPop msg="数据发送中，请稍候..." /> }
		</OpensaleCombiner>
    }
}

const OpensaleCombiner = ({topbar,popcomp,swiper,children})=>{
	return <div>
		{topbar}
		{popcomp}
		<div className="np-main">
			<div className="np-buy-box">
				{swiper}
				<div className="np-buy-main">
					{children}
				</div>
			</div>
		</div>
	</div>
}
const OfficialPrice = ()=>{
	return <div className="np-buy-text">
		<h2>{t('banner_title')}</h2>
		{t('sub_title')}
		{t('price_official_v2')}
	</div>
}

const ColorSelector = ({sellout,changeShoppingList,blue,black,orange,selectedColor,changeImageColor})=>{
	return <div className="np-buy-unit">
	<dl className="np-buy-color-new">
		<dt>请选择颜色</dt>
		<dd className={sellout.blue ? 'np-buy-soldout' : selectedColor=='blue'? 'np-selected' : '' } onClick={()=>{changeImageColor('blue')}}>
			<div className="np-select-item"><i className="np-dot-blue"></i>科技蓝</div>
			<BlueCounterInOpensale value={blue} changeShoppingList={changeShoppingList} sellout={sellout.blue}/>
		</dd>
		<dd className={sellout.orange ? 'np-buy-soldout' : selectedColor=='orange'? 'np-selected' : ''  } onClick={()=>{changeImageColor('orange')}}>
			<div className="np-select-item"><i className="np-dot-org"></i>爱马仕橙</div>
			<OrangeCounterInOpensale value={orange} changeShoppingList={changeShoppingList} sellout={sellout.orange}/>
		</dd>
		<dd className={sellout.black ? 'np-buy-soldout' : selectedColor=='black'? 'np-selected' : '' } onClick={()=>{changeImageColor('black')}}>
			<div className="np-select-item"><i className="np-dot-black"></i>曜石黑</div>
			<BlackCounterInOpensale value={black} changeShoppingList={changeShoppingList} sellout={sellout.black}/>
		</dd>
	</dl>
</div>
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/OpensalePurchaseV3.js